import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from 'prop-types';
import { useParams } from "react-router-dom";
import TenantUsers from "./components/tenantUsers";
import TenantConfig from "./components/tenantConfig";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function Store() {
    const { tenantId } = useParams();

    const [tabStore, setTabStore] = useState(0);
    const handleChangTab = (event, newValue) => {
        setTabStore(newValue);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabStore} onChange={handleChangTab} aria-label="basic tabs example">
                        <Tab label="Configurações" {...a11yProps(0)} />
                        <Tab label="Usuários" {...a11yProps(1)} />
                    </Tabs>
                </Box>
            </Box>
            <TabPanel value={tabStore} index={0}>
                <TenantConfig
                    tenantId={tenantId}
                />
            </TabPanel>
            <TabPanel value={tabStore} index={1}>
                <TenantUsers
                    tenantId={tenantId}
                />
            </TabPanel>

            <Footer />
        </DashboardLayout >
    );
}

export default Store;